import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-link-measurements',
  templateUrl: './link-measurements.component.html',
  styleUrls: ['./link-measurements.component.scss']
})
export class LinkMeasurementsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
